import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowArtistCreate = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "artist":
        if (
          !permission.isUserReadable() ||
          !permission.isUserEditable() ||
          !permission.isGroupReadable() ||
          !permission.isGroupEditable() ||
          !permission.isOtherWritable()
        ) {
          return false;
        }
        break;
      case "artist_title":
        if (!permission.isUserReadable() || !permission.isUserEditable()) {
          return false;
        }
        break;
      case "artist_url":
        if (!permission.isUserReadable() || !permission.isUserEditable()) {
          return false;
        }
        break;
      case "artist_history":
        if (!permission.isUserReadable() || !permission.isUserEditable()) {
          return false;
        }
        break;
      case "artist_role_relation":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "artist_company_relation":
        if (!permission.isUserReadable() || !permission.isUserEditable()) {
          return false;
        }
        break;
      case "role":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "role_title":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "users":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
